class BlankConstructor {
}

let Power3: any = BlankConstructor,
	Elastic: any = BlankConstructor,
	Back: any = BlankConstructor,
	Linear: any = BlankConstructor,
	TimelineMax: any = BlankConstructor,
	TweenMax: any = BlankConstructor,
	gsap: any = BlankConstructor,
	scrollToPlugin: any = BlankConstructor,
	ScrollTrigger: any = BlankConstructor,
	CSSRulePlugin: any = BlankConstructor,
	CSSPlugin: any = BlankConstructor;

if (typeof window !== 'undefined') {
	gsap = require('gsap/all').gsap;
	ScrollTrigger = require('gsap/all').ScrollTrigger;
	CSSRulePlugin = require('gsap/all').CSSRulePlugin;
	CSSPlugin = require('gsap/all').CSSPlugin;
	Power3 = require('gsap/all').Power3;
	Elastic = require('gsap/all').Elastic;
	Back = require('gsap/all').Back;
	Linear = require('gsap/all').Linear;
	TweenMax = require('gsap/all').TweenMax;
	TimelineMax = require('gsap/all').TimelineMax;
	scrollToPlugin = require('gsap/all').ScrollToPlugin;

	gsap.registerPlugin(
		scrollToPlugin,
		ScrollTrigger,
		CSSPlugin,
		CSSRulePlugin
	);
}

export {
	gsap,
	Power3,
	Elastic,
	Back,
	Linear,
	TimelineMax,
	TweenMax,
	ScrollTrigger
}
